import { toast } from "react-toastify";
import NotificationComponent from "../../components/Notification/Notification";

interface NotificationProps {
  status?: "success" | "error" | "info";
  title: string;
  description: string;
  acceptText?: string;
  acceptHandler?: () => void;
  rejectText?: string;
  rejectHandler?: () => void;
}

const lastToastIds: Record<string, string | number> = {};
const minTime = 7000;
const maxTime = 15000;
const minLength = 1;
const maxLength = 91;

function findShowTime(description: string) {
  const descriptionLength = description.length;
  const showTime =
    descriptionLength <= maxLength
      ? minTime +
        (maxTime - minTime) *
          ((descriptionLength - minLength) / (maxLength - minLength))
      : maxTime;
  return showTime;
}

export function displayNotImplemented() {
  displayNotify({
    status: "info",
    title: "Киберштаб",
    description: "В разработке",
  });
}

export function displayError() {
  displayNotify({
    status: "error",
    title: "Ошибка",
    description: "Ошибка",
  });
}

export function displaySuccesCopyLink() {
  displayNotify({
    status: "success",
    title: "Скопировано",
    description: "Отправьте ссылку друзьям",
  });
}

export function displaySuccessUpdate() {
  displayNotify({
    status: "success",
    title: "Изменения сохранены",
    description: "Информация профиля обновлена",
  });
}

export function displayNotSaved() {
  displayNotify({
    status: "error",
    title: "Данные не сохранены",
    description: "Для смены вкладок сохраните изменения",
  });
}

export function displayInfoMessage() {
  displayNotify({
    status: "info",
    title: "Инфо",
    description: "Это информационное сообщение",
  });
}

export function displayNotify({
  status,
  title,
  description,
}: NotificationProps) {
  const notificationKey = `${status}_${title}_${description}`;
  const showTime = findShowTime(description);

  if (
    lastToastIds[notificationKey] &&
    toast.isActive(lastToastIds[notificationKey])
  ) {
    toast.update(lastToastIds[notificationKey], {
      render: (
        <NotificationComponent
          closeToast={() => {
            toast.dismiss(lastToastIds[notificationKey]);
          }}
          status={status}
          title={title}
          description={description}
        />
      ),
      autoClose: showTime,
    });
  } else {
    const toastId = toast(
      <NotificationComponent
        closeToast={() => {
          toast.dismiss(toastId);
        }}
        status={status}
        title={title}
        description={description}
      />,
      {
        hideProgressBar: true,
        closeButton: false,
        autoClose: showTime,
      }
    );
    lastToastIds[notificationKey] = toastId;
  }
}

export function displayStandartDialog() {
  dialogNotify({
    status: "success",
    title: "Это диалог",
    description: "Всё хорошо?",
    acceptText: "Хорошо",
    rejectText: "Нет",
  });
}

export function displayCloseModalDialog(acceptHandler: () => void) {
  dialogNotify({
    status: "info",
    title: "Закрытие окна",
    description: "Данные не сохранятся. Закрыть окно?",
    acceptText: "Хорошо",
    rejectText: "Нет",
    acceptHandler,
  });
}

export function dialogNotify({
  status,
  title,
  description,
  acceptHandler,
  acceptText,
  rejectText,
}: NotificationProps) {
  const showTime = findShowTime(description);
  function closeAfterAccept() {
    acceptHandler && acceptHandler();
    toast.dismiss(toastId);
  }

  const toastId = toast(
    <NotificationComponent
      closeToast={() => {
        toast.dismiss(toastId);
      }}
      status={status}
      title={title}
      description={description}
      acceptText={acceptText}
      rejectText={rejectText}
      rejectHandler={() => {
        toast.dismiss(toastId);
      }}
      acceptHandler={closeAfterAccept}
    />,
    {
      hideProgressBar: true,
      closeButton: false,
      autoClose: showTime,
    }
  );
}
